// Module
var code = "<react-component name=\"GradingEventsList\"></react-component>\n";
// Exports
module.exports = code;